/**
 * Format duration for numeric input fields
 * 2.0 → "2", 2.5 → "2.5", 2.50 → "2.5"
 */
export function formatDuration(value: number): string {
  // Use toFixed to get consistent decimal places, then remove trailing zeros
  const fixed = value.toFixed(2);
  // Remove trailing zeros after decimal point
  return fixed.replace(/\.?0+$/, '');
}

/**
 * Format duration for display in human-readable format
 * Under 60s: show seconds (e.g., "2s", "2.5s")
 * 60s and above: show minutes + seconds (e.g., "1m", "1m 30s", "2m 15s")
 */
export function formatDurationDisplay(value: number): string {
  if (value < 60) {
    // Under 60 seconds: show just seconds
    const fixed = value.toFixed(2);
    // Remove trailing zeros after decimal point
    const cleaned = fixed.replace(/\.?0+$/, '');
    return `${cleaned}s`;
  }

  // 60 seconds and above: show minutes + seconds
  const minutes = Math.floor(value / 60);
  const seconds = value % 60;

  if (seconds === 0) {
    return `${minutes}m`;
  }

  // Format seconds, removing trailing zeros
  const secFixed = seconds.toFixed(2).replace(/\.?0+$/, '');
  return `${minutes}m ${secFixed}s`;
}
